export enum SemesterName {
  Winter = 'HOME.ROOT.ENROLLMENT-PORTAL-HEADER.WINTER-SEMESTER',
  Summer = 'HOME.ROOT.ENROLLMENT-PORTAL-HEADER.SUMMER-SEMESTER'
}
